import { connect } from 'react-redux';
import { ROUTE_ACCOUNTS_SUBSCRIPTIONS } from '../../../ReduxStorage/routeActions';
import { selectCourseAlertBanners } from '../../../ReduxStorage/Courses/CourseAlertBanners/selectors';
import { showEducatorModal } from '../../../ReduxStorage/SubscriptionPlans/SubscribeModals/dispatchers';
import { CourseAlertBanners } from './CourseAlertBanners';

function mapStateToProps(state) {
  return {
    banners: selectCourseAlertBanners(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onEducatorTrialBannerClick: () => {
      dispatch(showEducatorModal(true));
    },
    onPersonalTrialBannerClick: () => {
      dispatch({
        type: ROUTE_ACCOUNTS_SUBSCRIPTIONS,
      });
    },
    onManageSubscriptionsClick: () => {
      dispatch({
        type: ROUTE_ACCOUNTS_SUBSCRIPTIONS,
      });
    },
  };
}

export const ConnectedCourseAlertBanners = connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseAlertBanners);
